(function ($, ns) {
    "use strict";

    var ThemeMap = function (context, opts, init) {

      this.$context = (context instanceof jQuery) ? context : $(context);

      this.map = null;
      this.panel = null;
      this.panelCache = {};
      this.searchCounter = {};

      if (opts) {
        this.opts = $.extend(this.getDefaultOpts(), opts);
      }

      if (init !== false && !$('body').hasClass('wp-admin')) {
        this.init();
      }
    };

    var parentPrototype = window.pew.getRegistryEntry('wdf-plugin-map').classDef.prototype;
    ThemeMap.prototype = jQuery.extend({}, parentPrototype);

    ThemeMap.prototype.loadContent = function (contentOpts) {
      parentPrototype.loadContent.call(this, contentOpts);
      if (contentOpts.id == '1' || contentOpts.id == '2' || contentOpts.id == '3' || contentOpts.id == '4') {
        this.loadImageOverlay();
      }
    };
    ThemeMap.prototype.registerEvents = function () {
      parentPrototype.registerEvents.call(this);
      this.registerCardToPointHighlights();
    };
    ThemeMap.prototype.enableMarkerHover = function (marker) {
      parentPrototype.enableMarkerHover.call(this, marker);
      if (this.isVille(marker)) {
        this.map.openInfoWindow(marker);
      }
    };
    ThemeMap.prototype.getHoverPopin = function (marker) {
      let hoverPopin = parentPrototype.getHoverPopin.call(this, marker);
      if (this.isVille(marker)) {
        hoverPopin.options.autoClose = false;
        hoverPopin.options.closeButton = false;
        setTimeout(() => {
          $(marker.hoverPopin._wrapper).hover(
            (e) => {
              this.markerHoverIn(marker);
            },
            (e) => {
              this.markerHoverOut(marker);
            }
          );
          $(marker.hoverPopin._wrapper).on('click', (e) => {
            window.location.href = marker.data.link;
          });
        }, 100);
      }
      return hoverPopin;
    };
    ThemeMap.prototype.isVille = function (marker) {
      return (marker && marker.options && marker.options.data && marker.options.data.col && marker.options.data.col === 'villes');
    };
    ThemeMap.prototype.markerHoverIn = function (marker) {
      parentPrototype.markerHoverIn.call(this, marker);
      if (this.isVille(marker)) {
        this.EventManager.trigger('map.ville.focus', marker);
        $(marker.hoverPopin._wrapper).addClass('focus');
      }
    };
    ThemeMap.prototype.markerHoverOut = function (marker) {
      if (this.isVille(marker)) {
        this.EventManager.trigger('map.ville.unfocus', marker);
        $(marker.hoverPopin._wrapper).removeClass('focus');
      } else {
        parentPrototype.markerHoverOut.call(this, marker);
      }
    };

    ThemeMap.prototype.loadImageOverlay = function () {
      const imageUrl = '/app/themes/wwp_child_theme/plugins/wwp-map/public/image/MAP.svg',
        imageBounds = [
          [43.62, 3.77], [43.095, 3.13]
        ],
        imageOpts = {
          opacity: 1,
        };
      const ov = L.imageOverlay(imageUrl, imageBounds, imageOpts).addTo(this.map.map);
    }
    ThemeMap.prototype.registerCardToPointHighlights = function () {
      this.EventManager.on('ville.card.hoverIn', (e, villeId) => {
        const markers = this.map.layers.villes.markers;
        for (let i in markers) {
          let m = markers[i];
          if (m.id !== 'villes__m' + villeId) {
            continue;
          }
          $(m.hoverPopin._wrapper).addClass('focus');
        }
      });
      this.EventManager.on('ville.card.hoverOut', (e, villeId) => {
        const markers = this.map.layers.villes.markers;
        for (let i in markers) {
          let m = markers[i];
          if (m.id !== 'villes__m' + villeId) {
            continue;
          }
          $(m.hoverPopin._wrapper).removeClass('focus');
        }
      });
    }

    window.pew.addRegistryEntry({key: 'wdf-plugin-map', domSelector: '.map-form, .module-map', classDef: ThemeMap});

  }
)(jQuery, window.wonderwp);
